export { InserirImagem } from './InserirImagem'
